import { api } from "@services/baseURL";

export const GetHistoricoByIdSolicitacao = async (pageSize, rowsPerPage, idSolicitacao) => {
    try {
        const response = await api.get(`SolicitacaoHistorico/${idSolicitacao}`, {
            headers: {
                Authorization: `Bearer authToken`,
            },
            params: {
                pageNumber: pageSize,
                pageSize: rowsPerPage,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar historico da solicitacao:', error);
        throw error;
    }
};

export default {
    GetHistoricoByIdSolicitacao,
};